var map = {
	"./AstroFrens1.jpg": "7be2",
	"./AstroFrens116.jpg": "25e7",
	"./AstroFrens12.jpg": "3965",
	"./AstroFrens13.jpg": "3e50",
	"./AstroFrens189.jpg": "70c3",
	"./AstroFrens190.jpg": "259b",
	"./AstroFrens192.jpg": "413c",
	"./AstroFrens198.jpg": "ad80",
	"./AstroFrens199.jpg": "68e0",
	"./AstroFrens201.jpg": "7b36",
	"./AstroFrens207.jpg": "c0ec",
	"./AstroFrens74.jpg": "0a9f",
	"./AstroFrens80.jpg": "35ff",
	"./AstroFrenz163.jpg": "2f7c",
	"./AstroFrenz2.jpg": "309e",
	"./AstroFrenz97.jpg": "536b",
	"./down-arrow.svg": "acd5",
	"./eth-icon.svg": "fe17",
	"./metamask-icon.svg": "c277",
	"./super-icon.svg": "0f6c",
	"./swiper_images/astro1.jpg": "c361",
	"./swiper_images/astro10.jpg": "199b",
	"./swiper_images/astro2.jpg": "375f",
	"./swiper_images/astro3.jpg": "c0e0",
	"./swiper_images/astro4.jpg": "0232",
	"./swiper_images/astro5.jpg": "a825",
	"./swiper_images/astro6.jpg": "9745",
	"./swiper_images/astro7.jpg": "4ce1",
	"./swiper_images/astro8.jpg": "0ab7",
	"./swiper_images/astro9.jpg": "b624",
	"./walletconnect-logo.svg": "c2bb",
	"./warning.svg": "d1d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";